import { Component, OnInit, Input } from '@angular/core';
import { WidgetCountryUsageSummaryDTO } from 'src/app/core/models/system/widget/widget-country-usage-summary.dto';

@Component({
  selector: 'app-country-usage-summary',
  templateUrl: './country-usage-summary.component.html',
  styleUrls: ['./country-usage-summary.component.scss']
})

export class CountryUsageSummaryComponent implements OnInit {
  
  @Input() countryUsageSummary: WidgetCountryUsageSummaryDTO[] | undefined;

  constructor() { }

  public ngOnInit(): void { }
}
